module.exports = __webpack_public_path__ + "img/1 (12).712edcb3.jpg";